// Flow 11 — help with escalation, Flow 12 — weekly review (lot 3).
export const FLOW11_TITLE = "Flow 11 — Aide et escalade";
export const FLOW11_STEPS = ["Je bloque", "Parent averti", "Réponse ou séance", "Traité"];

export const FLOW12_TITLE = "Flow 12 — Bilan de la semaine";
export const FLOW12_STEPS = ["Courriel samedi midi", "Bilan à la connexion", "Bilan à la demande"];

const kid = (ctx) => ctx.child || ctx.studentName || "votre enfant";

const H = (key, step, label, prompt, text) => ({ key, flowId: 11, step, label, prompt, text });
const R = (key, step, label, prompt, text) => ({ key, flowId: 12, step, label, prompt, text });

export const LOT3_MESSAGES = [
  H("h.askIntro", 0, "Je bloque : intro", "L'élève signale une difficulté sur une activité.", () =>
    "Pas de souci, ça arrive. Dis-moi sur quel plan d’étude tu bloques, je préviens ton parent."),
  H("h.noActive", 0, "Aucune activité active", "L'élève veut de l'aide mais n'a aucune activité en cours.", () =>
    "Tu n’as pas de plan d’étude en cours pour l’instant. Tu peux en créer un ou attendre une proposition."),
  H("h.sent", 1, "Demande envoyée", "Confirmation à l'élève : le parent est averti.", (ctx) =>
    `C’est envoyé. ${ctx.parentName || "Ton parent"} est averti et va te répondre ici.`),
  H("h.parentAlert", 1, "Parent averti", "Le parent voit les demandes d'aide ouvertes.", (ctx) =>
    `${kid(ctx)} a besoin d’un coup de main. Vous pouvez répondre, proposer une séance ou passer la main au tuteur.`),
  H("h.parentNone", 1, "Aucune demande", "Le parent ouvre /aide sans demande en cours.", (ctx) =>
    `Aucune demande d’aide en cours pour ${kid(ctx)}.`),
  H("h.studentUpdate", 2, "Nouvelle réponse", "L'élève voit la réponse ou la séance proposée par son parent.", () =>
    "Ton parent t’a répondu :"),
  H("h.parentDone", 3, "Action faite", "Confirmation au parent après une action sur la demande.", (ctx) =>
    `C’est noté. ${kid(ctx)} le verra dans sa conversation.`),
  R("r.mailSim", 0, "Courriel simulé", "Samedi midi : le courriel « Ton bilan est prêt » (simulé dans le simulateur).", () =>
    "Courriel « Ton bilan est prêt » envoyé (simulation)."),
  R("r.pending", 1, "Bilan à la connexion", "Première connexion après samedi : le bilan de la semaine passée s'affiche.", () =>
    "La semaine est terminée. Voici le bilan :"),
  R("r.onDemand", 2, "Bilan à la demande", "/bilan à tout moment : la semaine en cours.", () =>
    "Voici le bilan de la semaine en cours :"),
];
